module.exports = __webpack_public_path__ + "files/Plattegrond Brielle hotel.3cce3bbd.pdf";